import { render, staticRenderFns } from "./DocDivider.vue?vue&type=template&id=2f07fc8d&"
import script from "./DocDivider.vue?vue&type=script&lang=js&"
export * from "./DocDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports